import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';

import { Cta } from 'apps/dashboard/shared/scripts/components';

const FAQCard = () => {
  // @todo(jgan): FAQ link
  return <Cta faIcon={faMagicWandSparkles}>FAQ</Cta>;
};

FAQCard.displayName = 'FAQCard';

export default FAQCard;
